var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"echartView",staticStyle:{"width":"23vw","height":"300px","margin-right":"30px"},attrs:{"id":"echartView2"}})}
var staticRenderFns = []

export { render, staticRenderFns }